import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

const SkillCard = ({ imgSrc, label, classes }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      whileHover={{
        scale: 1.1,
        rotate: 2,
        boxShadow: '0 15px 20px rgba(0, 0, 0, 0.2)',
        transition: { type: "spring", stiffness: 300 },
      }}
      className={`skill-card flex items-center gap-3 ring-2 ring-inset ring-zinc-50/10 rounded-2xl p-3 hover:bg-zinc-700 transition-colors group ${classes}`}
    >
      <figure className="bg-zinc-700/50 rounded-lg overflow-hidden w-12 h-12 p-2 group-hover:bg-zinc-900 transition-colors">
        <img src={imgSrc} width={32} height={32} alt={label} />
      </figure>
      <div>
        <h3>{label}</h3>
      </div>
    </motion.div>
  );
};

SkillCard.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  classes: PropTypes.string,
};

export default SkillCard;